/* eslint-disable @typescript-eslint/no-magic-numbers */
import {Browser} from '@clappr/core'

export class BrowserAdInfo {
  public static getDeviceName(): string {
    if (Browser.isAndroid) {
      return '1'
    }

    if (Browser.isiOS) {
      return '0'
    }

    return ''
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  public static getDeviceType(): string {
    const {isMobile, userAgent, os} = Browser

    if (os.name === 'iPhone' || os.name === 'iPod') {
      return '1'
    }

    if (os.name === 'iPad') {
      return '2'
    }

    if (os.name === 'Android' && window.screen?.width <= 1280) {
      return '3'
    }

    if (os.name === 'Android') {
      return '4'
    }

    if (os.name === 'Windows Phone') {
      return '5'
    }

    if (~userAgent.indexOf('tizen') && window.screen?.width <= 1280) {
      return '7'
    }

    if (~userAgent.indexOf('tizen')) {
      return '8'
    }

    if (isMobile) {
      return '15'
    }

    if (!~userAgent.indexOf('SmartTV')) {
      return '16'
    }

    if (~userAgent.indexOf('NetCast') || ~userAgent.indexOf('LG')) {
      return '9'
    }

    if (~userAgent.indexOf('Samsung') || ~userAgent.indexOf('X11')) {
      return '10'
    }

    if (~userAgent.indexOf('Philips')) {
      return '11'
    }

    if (~userAgent.indexOf('Sony')) {
      return '12'
    }

    return '14'
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  public static getBrowserName(): string {
    const {isMobile, userAgent, data, os} = Browser

    if (~userAgent.indexOf('YaBrowser')) {
      data.name = 'YaBrowser'
    }

    if (~userAgent.indexOf('OPR')) {
      data.name = 'Opera'
    }

    if (~userAgent.indexOf('Edg')) {
      data.name = 'Edge'
    }

    if (isMobile) {
      if (data.name === 'YaBrowser') {
        return '6'
      }

      if (data.group === 'Edge' || data.name === 'Edge') {
        return '22'
      }

      if (data.group === 'Opera' || data.name === 'Opera') {
        return '24'
      }

      if (data.name === 'Chrome Mobile' || data.group === 'Chrome') {
        return '7'
      }

      if (data.name === 'Android Browser') {
        return '20'
      }

      if (data.group === 'Explorer') {
        return '21'
      }

      if (data.group === 'Firefox') {
        return '23'
      }

      if (data.group === 'Safari' && os.name === 'iPad') {
        return '25'
      }

      if (data.group === 'Safari' && os.name === 'iPhone') {
        return '26'
      }
    } else {
      if (data.group === 'Explorer') {
        return '1'
      }

      if (data.name === 'YaBrowser') {
        return '6'
      }

      if (data.group === 'Edge' || data.name === 'Edge') {
        return '2'
      }

      if (data.group === 'Opera' || data.name === 'Opera') {
        return '9'
      }

      if (data.group === 'Firefox') {
        return '3'
      }

      if (data.group === 'Netscape') {
        return '4'
      }

      if (data.group === 'Safari') {
        return '5'
      }

      if (data.group === 'Chrome') {
        return '7'
      }

      if (data.group === 'Mozilla') {
        return '8'
      }
    }

    return '27'
  }

  public static getScreenSize({
    width = 640,
    minWidth = 0
  }: {
    width: number
    minWidth: number
  }): string {
    const resultWidth = width < minWidth ? minWidth : width

    if (resultWidth < 400) {
      return '5'
    }

    if (resultWidth < 640) {
      return '0'
    }

    if (resultWidth < 960) {
      return '1'
    }

    if (resultWidth < 1280) {
      return '2'
    }

    if (resultWidth >= 1280) {
      return '3'
    }

    return '4'
  }
}
